import { render, staticRenderFns } from "./MindMapCard.vue?vue&type=template&id=90cf4f74&scoped=true&"
import script from "./MindMapCard.vue?vue&type=script&lang=js&"
export * from "./MindMapCard.vue?vue&type=script&lang=js&"
import style0 from "./MindMapCard.vue?vue&type=style&index=0&id=90cf4f74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90cf4f74",
  null
  
)

export default component.exports